<template>
  <div>
    <a-list style="height: 100%">
      <div slot="header" style="padding-top: 20px">
        <span class="titleClass">音乐和歌单</span>
        <br/><br/>
        <span>音乐设置/歌单设置</span>
      </div>
      <a-list-item style="padding: 20px">
        <span>默认歌单</span>
        <a-icon type="edit" theme="twoTone" style="position: absolute;right: 5px;font-size: 20px"
                @click="showEditPlaylist"/>
        <br/><br/>
        {{ defaultValue }}
      </a-list-item>
    </a-list>
    <a-modal v-model="editPlaylistVisible" title="默认歌单" ok-text="确认" cancel-text="取消" @ok="submitPlaylist"
             :confirm-loading="confirmLoading">
      <a-form-model layout="vertical" :model="playlistForm" ref="playlistRef">
        <a-form-model-item label="请选择默认歌单" prop="defaultPlayList">
          <a-select v-model="playlistForm.defaultPlaylist" placeholder="请选择默认歌单">
            <a-select-option v-for="item in playList" :value="item.code">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import PlayListRequest from "@/store/RequestModules/PlayListRequest";
import UserConfigurationRequest from "@/store/RequestModules/UserConfigurationRequest";
import SystemUserRequest from "@/store/RequestModules/SystemUserRequest";

export default {
  name: "MusicConfiguration",
  data() {
    return {
      editPlaylistVisible: false,
      confirmLoading: false,
      playList: [],
      playlistForm: {
        defaultPlaylist: ''
      },
      rules: {
        defaultPlayList: [{required: true, message: '歌单不能为空', trigger: 'change'},]
      },
      defaultValue: ''
    };
  },
  methods: {
    showEditPlaylist() {
      this.editPlaylistVisible = true;
    },
    submitPlaylist() {
      if (this.playlistForm.defaultPlaylist === '' || this.playlistForm.defaultPlaylist === undefined) {
        this.$message.error("默认歌单不能为空")
      }
      this.confirmLoading = true
      UserConfigurationRequest.updateUserConfiguration(this.playlistForm).then(res => {
        if (res.status == '200') {
          SystemUserRequest.info().then(res => {
            const userInfo = res.data.data;
            this.$store.commit("SET_USERINFO", userInfo);
            this.imageUrl = userInfo.avatar
          })
        }
      }).finally(() => {
        this.confirmLoading = false
        this.editPlaylistVisible = false;
      })

    },

  },
  created() {
    // 获取当前用户播放列表
    PlayListRequest.getUserPlayList(this.$store.state.userInfo.code).then(res => {
      if (res.status == '200') {
        this.playList = res.data.data
        this.playlistForm.defaultPlaylist = this.$store.state.userInfo.defaultPlaylist
        if (this.playList && this.playList.length > 0) {
          this.defaultValue = this.playList.filter(item => item.code === this.playlistForm.defaultPlaylist)[0].name
        }
      }
    })
  }

}
</script>

<style scoped>
.titleClass {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
}
</style>